import { useSaveActions } from "../../common"
import { TableName } from "../../../tables"
import { Ticket } from "../state/types"

export const useTicketActions = () => {
    const saveActions = useSaveActions()

    const saveTicket = (ticket: Ticket) => {
        const { save } = saveActions()
        return save(TableName.TICKETS, ticket) as Promise<Ticket>
    }

    const removeTicket = (id: string) => {
        const { remove } = saveActions()
        return remove(TableName.TICKETS, id)
    }

    return {
        saveTicket,
        removeTicket
    }
}
